import { render } from "./TotalAccountsPayable.vue?vue&type=template&id=556c65bc"
import script from "./TotalAccountsPayable.vue?vue&type=script&lang=js"
export * from "./TotalAccountsPayable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__